<template>
    <div>
        <main id="main">
            <!-- <KeepAlive> -->
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            <!-- </KeepAlive> -->
        </main>
    </div>
</template>

<script>
export default {
    created() {
        const currentUrl = window.location.href;
        const urlParams = new URLSearchParams(new URL(currentUrl).search);

        if (urlParams.has("utm_campaign") || urlParams.has("internal_campaign")) {
            const paramKey = urlParams.has("utm_campaign")
                ? "utm_campaign"
                : "internal_campaign";

            // check session storage
            if (sessionStorage.getItem("session_referral") === null) {
                sessionStorage.setItem(
                    "session_referral",
                    `${paramKey}=${urlParams.get(paramKey)}`,
                );
            }
        }
    }
};
</script>

<style scss>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
